import styled, { css } from 'styled-components';

import { HorizontalNavProps } from '../../HorizontalNav/HorizontalNav';
import { horizontalNavTokens } from '../../../tokens/components/HorizontalNav/tokens';

const NavWrapper = styled.nav<HorizontalNavProps>`
  border-bottom: 1px solid ${horizontalNavTokens.CoreColorDivider};
  display: flex;
  flex-wrap: nowrap;
  height: auto;
  white-space: nowrap;
  justify-content: ${({ theme }) => (theme.navWrapperAlign === 'center' && theme.navWrapperAlign) || 'start'};

  ${({ theme }) =>
    theme.navWrapperHasSidePadding &&
    css`
      padding: 0 ${horizontalNavTokens.CoreSpacingSide};
    `};

  ${({ theme }) =>
    theme.isSubNav &&
    css`
      padding-bottom: 9px;
    `};
`;

export default NavWrapper;
